window.Cdek = {
	Map: {
		map: null,
		clustererPoints: null,
		cachedPoints: [],
		points: [],
		init: function (callback = null) {
			if (typeof ymaps == 'undefined' || !$('#modal-cdek').length) {
				return;
			}

			if (this.map && callback) {
				this.map.container.fitToViewport();
				callback();
				return;
			}

			let self = this;

			ymaps.ready(function () {
				self.map = new ymaps.Map("cdek-map", {
					center: [55.76, 37.64],
					controls: ['zoomControl'],
					zoom: 13
				}, {
					searchControlProvider: 'yandex#search'
				});

				self.makeClusters();

				self.map.panes.get('ground').getElement().style.filter = 'grayscale(100%)';

				if (callback) callback();
			});
		},

		makeClusters: function () {
			this.clustererPoints = new ymaps.Clusterer({
				clusterIconColor: '#1AB248',
				minClusterSize: 3,
			});

			let stateMonitor;
			this.clustererPoints.events.add('balloonopen', function (e) {
				let cluster = e.get('cluster');
				if (cluster) {
					let activeObject = cluster.state.get('activeObject');
					if (activeObject) {
						let id = activeObject.properties.get('id');
						Cdek.Map.loadBalloonContent(id, activeObject);
					}

					if (stateMonitor) {
						stateMonitor.removeAll();
					}
					stateMonitor = new ymaps.Monitor(cluster.state);
					stateMonitor.add('activeObject', function (activeObject) {
						let id = activeObject.properties.get('id');
						Cdek.Map.loadBalloonContent(id, activeObject);
					});
				} else {
					let target = e.get('target');
					if (target) {
						let id = target.properties.get('id');
						Cdek.Map.loadBalloonContent(id, target);
					}
				}
			});

			this.map.geoObjects.add(this.clustererPoints);
		},

		addPoints: function (points) {
			this.clustererPoints.removeAll();
			this.points = points;

			for (let i in points) {
				this.addPoint(points[i]);
			}

			let countPoints = Object.keys(points).length;
			if (countPoints > 1) {
				this.map.setBounds(this.clustererPoints.getBounds());
			} else if (countPoints > 0) {
				let firstKey = Object.keys(points)[0];
				this.map.setCenter([
					points[firstKey].lat,
					points[firstKey].lon
				], 15);
			}
		},

		addPoint: function (point) {
			let path =  'islands#icon';

			if (point.type === 'POSTAMAT') {
				path = '/assets/_frontend/images/icons/cdek_postamat.svg';
			} else if (point.type === 'PVZ') {
				path = '/assets/_frontend/images/icons/cdek_pvz.svg';
			}

			let placemark = new ymaps.Placemark(
				[
					point.lat,
					point.lon
				],
				{
					"id": point.id,
					"balloonContentHeader": point.title,
					"balloonContentBody": (function () {
						return [
							`<ul class="list list-column list-cdek-info"><li class="list-item"><span>Адрес пункта выдачи:</span> <b>${point.address}</b></li>`,
							point.address_comment ? `<li class="list-item"><span>Комментарий</span><b>${point.address_comment}</b></li>` : null,
							point.worktime ? `<li class="list-item"><span>Время работы</span><b>${point.worktime}</b></li>` : null,
							`<li class="list-item"><span>Условия доставки</span>`,
								`<div class="cdek-delivery">Стоимость доставки: <b class="price"> <i class="fa fa-spin fa-spinner"></i> загрузка...</b></div>`,
								`<div class="cdek-delivery">Срок доставки: <b class="days"> <i class="fa fa-spin fa-spinner"></i> загрузка...</b></div></ul>`,
							`</li>`,
							`<div class="cdek-button"><button type="button" class="btn-set-point" data-id="${point.id}">Выбрать</button></div>`
						].filter(Boolean).join('')
					})(),
					"clusterCaption": point.address,
				}, {
					iconLayout: 'default#image',
					iconImageHref: path,
					iconImageSize: [39, 50],
					iconImageOffset: [-3, -42]
				}
			);

			this.clustererPoints.add(placemark);
		},

		loadBalloonContent: function (id, activeObject) {
			let html = activeObject.properties.get('balloonContentBody');
			let $html = $('<div>').append(html);

			let route = '/cart/cdek/get_price';
			let params = {
				cdek_point_id: id
			};
			$.get(route, params, function (data) {
				$html.find('.price').text(output_roubles(data.price));
				$html.find('.days').text(data.days);
				activeObject.properties.set('balloonContentBody', $html.html());
			});
		},

		openPoint: function (id) {
			let point = this.getPointById(id);
			if (point) {
				this.map.setCenter(point.geometry.getCoordinates(), 13);
				let objectState = this.clustererPoints.getObjectState(point);
				if (objectState.isClustered) {
					objectState.cluster.state.set('activeObject', point);
					this.clustererPoints.balloon.open(objectState.cluster);
				} else if (objectState.isShown) {
					point.balloon.open();
				}
			}
		},

		getPointInfoById: function (id) {
			return this.points[id];
		},

		getPointById: function (id) {
			if (typeof this.cachedPoints[id] === 'undefined') {
				let geoObjects = this.clustererPoints.getGeoObjects();
				for (let i = 0; i < geoObjects.length; i++) {
					let pointId = geoObjects[i].properties.get('id');
					if (pointId === id) {
						this.cachedPoints[id] = geoObjects[i];
					}
				}
			}

			return this.cachedPoints[id] || false;
		},

		showPoint: function (id) {
			//this.getPointById(id)?.options.set('visible', true);
		},

		hidePoint: function (id) {
			//this.getPointById(id);
			//this.clustererPoints.remove(this.getPointById(id))
		},

		hidePoints: function () {
			this.clustererPoints.removeAll();
		},

		selectPoint: function (id) {
			let point = this.getPointInfoById(id),
				$form = $('#form-cart'),
				$cdek = $form.find('.delivery-cdek');

			$cdek.attr('data-point_id', id);
			$cdek.find('[name=cdek_point_id]').val(id);

			let $cdekInfo = $cdek.find('.info');

			$cdekInfo.find('.address .addr').text(point.address);
			if (point.address_comment) {
				$cdekInfo.find('.address .comment')
					.attr('data-bs-original-title', point.address_comment)
					.show();
			} else {
				$cdekInfo.find('.address .comment').hide();
			}

			$cdekInfo.find('.worktime').text(point.worktime);
			$cdekInfo.closest('.selected-point-info').show();
		},
		resetPoint: function () {
			let $form = $('#form-cart');
			let $cdek = $form.find('.delivery-cdek');
			$cdek.attr('data-point_id', 0);
			$cdek.find('[name=cdek_point_id]').val(0);
		},
		filterPoints: function ($modalCdek) {
			let $filters = $modalCdek.find('.filters');
			let s = $filters.find('[name=s]').val().toLowerCase();
			let types = $filters.find('.f-type:checked').map(function () {
				return $(this).val();
			}).toArray();

			Cdek.Map.hidePoints();

			let searchEmpty = true;
			let $itemsContainer = $modalCdek.find('.items-container');
			$itemsContainer.find('.point').each(function (i, pointElement) {
				let id = $(this).data('id');
				let pointData = Cdek.Map.getPointInfoById(id);
				let searchOk = [
					// search
					(function () {
						let searchString = [
							pointData.address
						].join(' ').toLowerCase();
						return searchString.indexOf(s) !== -1;
					})(),
					// filter type
					(function () {
						return types.indexOf(pointData.type) !== -1;
					})(),
				].filter(Boolean).length === 2;

				if (searchOk) {
					$(pointElement).removeClass('d-none');
					Cdek.Map.addPoint(pointData);
					searchEmpty = false;
				} else {
					$(pointElement).addClass('d-none');
					Cdek.Map.hidePoint(pointData.id);
				}
			});

			if (searchEmpty) {
				$itemsContainer.attr('data-empty', 1);
			} else {
				$itemsContainer.attr('data-empty', 0);
			}
		}
	}
};

$(document).ready(function () {
	let $modalCdek = $('#modal-cdek');
	let $selectCityCdek = $('[name=cdek_city_id]');
	let $formOrder = $('#form-cart');

	$selectCityCdek.select2({
		ajax: {
			delay: 250,
			url: $selectCityCdek.data('route'),
			dataType: 'json',
			processResults: function (data) {
				return {
					results: data.items
				};
			}
		},
		escapeMarkup: function (markup) {
			return markup;
		},
		templateResult: function (state) {
			let text = state.text;
			if (state.region) {
				text += ` <span>${state.region}</span>`;
			}

			return text;
		},
	});

	$selectCityCdek.change(function () {
		$modalCdek.data('city_id', $(this).val());
		$modalCdek.modal('show');
	});

	$modalCdek.on('shown.bs.modal', function () {
		let self = this;

		Cdek.Map.init(function () {
			let city_id = $(self).data('city_id');
			let route = $(self).data('route');
			let params = {
				city_id: city_id
			};

			$.get(route, params, function (data) {
				$modalCdek.find('.modal-content .items-container').html(data.view);

				Cdek.Map.addPoints(data.points);
			});
		});
	});

	$modalCdek.find('.filters input[name=s]').on('keydown input change', function () {
		Cdek.Map.filterPoints($modalCdek);
	});
	$modalCdek.find('.filters input[type=checkbox]').on('change', function () {
		Cdek.Map.filterPoints($modalCdek);
	});

	$modalCdek.on('click', '.point', function () {
		$modalCdek.find('.point').removeClass('selected');
		$(this).addClass('selected');
		Cdek.Map.openPoint($(this).data('id'));
	});

	$modalCdek.on('click', '.btn-set-point', function () {
		Cdek.Map.selectPoint($(this).data('id'));
		$modalCdek.modal('hide');
		VegasCatalog.Cart.updateTotalAll();
	});

	$('.delivery-cdek .btn-change-point').click(function () {
		$modalCdek.data('city_id', $formOrder.find('[name=cdek_city_id]').val());
		$modalCdek.modal('show');
		return false;
	});
});
